import { Component, OnInit } from '@angular/core';

@Component({
   selector: 'samweb-audio-settings',
   templateUrl: './audio-settings.component.html',
   styleUrls: ['./audio-settings.component.scss'],
})
export class AudioSettingsComponent implements OnInit {
   constructor() {}

   ngOnInit() {}
}
